'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateConstants = generateConstants;
exports.setBackground = setBackground;
exports.setBoxShadow = setBoxShadow;
// NOTE: ARROW_BASE is the actual size of the Arrow div
function generateConstants(_ref) {
  var ARROW_BASE = _ref.ARROW_BASE,
      BROWSER_OFFSET = _ref.BROWSER_OFFSET;

  // ARROW_HEIGHT and ARROW_WIDTH are the dimensions for the visible half of the Arrow
  var ARROW_HEIGHT = function ARROW_HEIGHT() {
    return ARROW_BASE / 2 - BROWSER_OFFSET;
  };

  var ARROW_WIDTH = function ARROW_WIDTH() {
    var HEIGHT = ARROW_HEIGHT();
    return Math.sqrt(HEIGHT * HEIGHT * 2);
  };

  // Yay for Pythagorus! c = √(a² + b²)
  var ARROW_HALF_WIDTH = function ARROW_HALF_WIDTH() {
    return ARROW_WIDTH() / 2;
  };

  // ARROW_OFFSET is how far the arrow is from the edge of the Popover
  var ARROW_OFFSET = function ARROW_OFFSET() {
    return ARROW_HALF_WIDTH() + 20;
  };

  return {
    ARROW_HEIGHT: ARROW_HEIGHT(),
    ARROW_WIDTH: ARROW_WIDTH(),
    ARROW_HALF_WIDTH: ARROW_HALF_WIDTH(),
    ARROW_OFFSET: ARROW_OFFSET(),

    // These constants are used to control the rotation of the pointer.
    BOTTOM_ROTATE: 45,
    LEFT_ROTATE: 135,
    RIGHT_ROTATE: -45,
    TOP_ROTATE: -135
  };
}

function setBackground(defaultColor, arrowColor) {
  var color = arrowColor || defaultColor;
  return 'linear-gradient(to bottom right, ' + color + ' 51%, transparent 0%)';
}

var BOX_SHADOWS = {
  bottom: '-2px -2px 2px -2px',
  left: '-3px -3px 6px -3px',
  right: '-3px -3px 6px -3px',
  top: '-2px -2px 4px -2px'
};

function setBoxShadow(direction, color) {
  return BOX_SHADOWS[direction] + ' ' + color;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/utils/arrow.js
// module id = 199
// module chunks = 2